/**
 * Country normalization utilities
 * Maps various country name formats to canonical names for consistent matching
 */

/**
 * Country name mappings - maps variations to canonical name
 */
const COUNTRY_MAPPINGS: Record<string, string> = {
  // United States variations
  'us': 'united states',
  'usa': 'united states',
  'united states of america': 'united states',
  'u.s.': 'united states',
  'u.s.a.': 'united states',

  // United Kingdom variations
  'uk': 'united kingdom',
  'gb': 'united kingdom',
  'great britain': 'united kingdom',
  'u.k.': 'united kingdom',

  // Other common variations
  'uae': 'united arab emirates',
  'u.a.e.': 'united arab emirates',
}

/**
 * Normalize a country name to its canonical form
 * Handles common abbreviations and variations
 */
export function normalizeCountryName(countryName: string): string {
  const normalized = countryName.toLowerCase().trim()
  return COUNTRY_MAPPINGS[normalized] || normalized
}

/**
 * Check if two country names refer to the same country
 * Handles variations like "US", "USA", "United States"
 */
export function isSameCountry(country1: string, country2: string): boolean {
  return normalizeCountryName(country1) === normalizeCountryName(country2)
}
